import { useMemo } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  white?: boolean;
  size?: 'sm' | 'md' | 'lg';
  sm?: boolean;
  lg?: boolean;
};

export default function Logo({ size = 'md', sm = false, lg = false }: Props) {
  const logoSize = useMemo(() => {
    if (sm || size === 'sm') {
      return { heightClass: 'h-5', widthClass: 'w-20', width: 80, height: 20 };
    } else if (lg || size === 'lg') {
      return {
        heightClass: 'h-20',
        widthClass: 'w-60',
        width: 240,
        height: 80,
      };
    } else {
      return {
        heightClass: 'h-10',
        widthClass: 'w-40',
        width: 160,
        height: 40,
      };
    }
  }, [sm, lg, size]);

  return (
    <Link to='/' className='flex items-center'>
      <img
        src='/imgs/logo/logo.svg'
        alt='Veggie World Logo'
        width={logoSize.width}
        height={logoSize.height}
        className='object-contain'
      />
    </Link>
  );
}
